import {
  typedHttpsCallableWrapper,
  typedOnRequestWrapper
} from '../api-_utils';
import { components } from './api-config/api-paths-v2.ts.types';
import { API_ROUTE_CONFIG } from './api-config/config';
type S = components['schemas']['LoginLink'];
export interface LoginLink extends S {}
export abstract class LoginLinkAPI {
  /**
   * Create a new Assessment Link for a Patient
   * @param patientId
   * @returns
   */
  public static create = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.loginLink.create
  );

  /**
   * Generate an Assessment Link token
   * @param assessmentLinkId
   * @returns
   */
  public static getTokenForLink = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.loginLink.getTokenForLink
  );

  public static list = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.loginLink.list
  );

  /**
   * Delete an assessment link
   * @param args
   * @returns
   */
  public static deactivate = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.loginLink.deactivate
  );

  /**
   * Use an assessment link token to sign in
   */
  public static consumeToken = typedOnRequestWrapper(
    API_ROUTE_CONFIG.patient.loginLink.useToken
  );
}
